import { Injectable, inject } from '@angular/core';
import {
  IQueryParam,
  IListado,
  IResumenDatosBase,
  ICoordenadas,
  MapaResumenDatos,
  ICreateResumenDatos,
  IResumenDatos,
  IUpdateResumenDatos,
} from 'modelos/src';
import { HelperService } from '../helper.service';
import { HttpClientService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class ResumenesDatosService {
  private http = inject(HttpClientService);


  public getFiltered<T extends keyof MapaResumenDatos>(
    queryParams?: IQueryParam,
  ): Promise<IListado<IResumenDatosBase<T>>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get<IListado<IResumenDatosBase<T>>>(`/resumenes-datos`, {
      params,
    });
  }

  public getById<T extends keyof MapaResumenDatos>(
    id: string,
  ): Promise<IResumenDatosBase<T>> {
    return this.http.get<IResumenDatosBase<T>>(`/resumenes-datos/${id}`);
  }

  public create(dato: ICreateResumenDatos): Promise<IResumenDatos> {
    return this.http.post(`/resumenes-datos`, dato);
  }

  public update(id: string, dato: IUpdateResumenDatos): Promise<IResumenDatos> {
    return this.http.put(`/resumenes-datos/${id}`, dato);
  }

  public delete(id: string): Promise<void> {
    return this.http.delete(`/resumenes-datos/${id}`);
  }
}
